import { Trans, useLingui } from '@lingui/react/macro';

import { CardItem, CardItems } from '@/components/Card/Card';
import { Body, Cell, Column, Header, Row, Table } from '@/design_system/Table/Table';
import Paragraph from '@/design_system/Typography/Paragraph';
import { ArticleWithRelations } from '@/models/request';

export const OtherServiceTable = ({ article }: { article: ArticleWithRelations }) => {
  const { t } = useLingui();

  return (
    <Table
      theme="brand"
      ariaLabel={t({ id: 'client.article.services', message: 'Services' })}
      columnWidths={['100%']}
      bordered
    >
      <Header>
        <Row>
          <Column>
            <Trans id="client.article.services.column.service">Service required</Trans>
          </Column>
        </Row>
      </Header>
      <Body>
        <Row>
          <Cell>
            <OtherServiceName article={article} />
          </Cell>
        </Row>
      </Body>
    </Table>
  );
};

export const OtherServiceCard = ({ article }: { article: ArticleWithRelations }) => {
  return (
    <CardItems>
      <CardItem>
        <OtherServiceName article={article} />
      </CardItem>
    </CardItems>
  );
};

const OtherServiceName = ({ article }: { article: ArticleWithRelations }) => {
  return (
    <Paragraph>
      {(article.snapshot.serviceChoice === 'exchange-archival' ||
        article.snapshot.serviceChoice === 'exchange') && (
        <Trans id="service-choice.radio.exchange-archival.label">Exchange</Trans>
      )}
      {article.snapshot.serviceChoice === 'refund' && (
        <Trans id="service-choice.radio.refund.label">Refund</Trans>
      )}
      {article.snapshot.serviceChoice === 'none' && (
        <Trans id="service-choice.radio.none.sub-text">No service can be provided</Trans>
      )}
    </Paragraph>
  );
};
